import { render } from "./TitleDivider.vue?vue&type=template&id=13527066"
import script from "./TitleDivider.vue?vue&type=script&lang=js"
export * from "./TitleDivider.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__